import React from "react";
import FormSection from "../../../../components/ChallengeArena/CreateChallengeForm/Layout/FormSection";

const AccountSection = ({
  title = "Section Title",
  subtitle = "",
  icon: Icon,
  action,
  danger = false,
  children
}) => {
  return (
    <div
      className={`rounded-2xl border p-4 sm:p-6 mb-2.5 sm:mb-3 shadow-sm ${
        danger ? "bg-red-50 border-red-100" : "bg-white border-gray-200"
      }`}
    >
      <div className="flex items-center justify-between gap-3 mb-1.5">
        <div className="flex items-center gap-2">
          {Icon && <Icon sx={{ fontSize: 18, color: danger ? "#DC2626" : "#98A2B3" }} />}
          <h3 className={`text-[15px] font-bold m-0 ${danger ? "text-red-600" : "text-gray-900"}`}>
            {title}
          </h3>
        </div>
        {action}
      </div>

      {subtitle && (
        <p className={`text-xs mb-2 sm:mb-3 ${danger ? "text-red-400" : "text-gray-400"}`}>
          {subtitle}
        </p>
      )}

      <FormSection>{children}</FormSection>
    </div>
  );
};

export default AccountSection;
